import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material";

import { PermissoesProvider } from "./Context/PermissoesContext";
import { AuthProvider } from "./Context/AuthContext";

import RoutasDNA from "./routes";

import { globalTheme } from "./theme/themeMUI";

function App() {
  const { pathname } = window.location;

  useEffect(() => {
    if (pathname === "/intranet") {
      window.location.href = "/";
    }
  }, []);

  return (
    <ThemeProvider theme={globalTheme}>
      <BrowserRouter>
        <AuthProvider>
          <PermissoesProvider>
            <RoutasDNA />
          </PermissoesProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
